import { render, staticRenderFns } from "./CockpitMatryoshkaItemHistoryList.vue?vue&type=template&id=bb6dbde4&scoped=true"
import script from "./CockpitMatryoshkaItemHistoryList.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemHistoryList.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaItemHistoryList.vue?vue&type=style&index=0&id=bb6dbde4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6dbde4",
  null
  
)

export default component.exports